export default "__VITE_ASSET__CtJ3uChv__"